import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { faCircleArrowLeft } from '@fortawesome/free-solid-svg-icons';

const BackButton = ({ history, className, style, children, t }) => {
	return <Button onClick={history.goBack} className={`btn btn-default ${className}`} style={style}>{children || <span><FontAwesomeIcon icon={faCircleArrowLeft} /> {t('Common_Back')}</span>}</Button>;
};

export default withTranslation()(withRouter(BackButton));